import { useEffect, useState } from 'react'
import CommanPhoneNumber from '../Ui/PhoneNumber'
import CommanForm from '../FormController/Commanform'
import MyProfileDetailValidation from '../../yup/MyProfile/MyProfileDetail'
import Errormessages from '../ErrorMessage/Errormessages'
import { RemoveImage, handleImageChange } from '../../pages/Profile/CompanyProfile/Image'
import { getLocationAddress, handleShowSwalConfirmation, validImageTypes, validateImage } from '../../utils/Helper'

import { useDispatch, useSelector } from 'react-redux'
import MyProfileImageItem from '../../pages/Dashboard/Pages/MyProfile/MyProfileImageItem'
import { SalonDetailAction, SalonUpdateAction } from '../../redux/Action/MyProfileAction'
import $ from "jquery"
import Button from '../Ui/Button'
import Spinner from '../Spinner'
import ProfileLocation from '../../pages/Profile/CompanyProfile/ProfileLocation'
import { RemoveProfileImageAction } from '../../redux/Action/ProfileAction'
import { FormattedMessage, useIntl } from 'react-intl';

const SalonDetailsEdit = ({ profileData }: any) => {
    const intl = useIntl();


    const profile_data = useSelector((state: any) => state.SalonUpdateState)
    const salon_detail = useSelector((state: any) => state.SalonDetailState)
    const profile = useSelector((state: any) => state.GetProfileState);

    const dispatch = useDispatch<any>();

    const [getImages, setGetImages] = useState(Array(0).fill(null));
    const [deletedImagesId, setDeletedImagesId] = useState([]);
    const [selectedImages, setSelectedImages]: any = useState<Array<{ file_path: string | null, media_id: number | string | null }>>([])
    const [imageData, setImageData] = useState([]);

    const { register, errors, handleSubmit, setValue, trigger, watch, getValues, reset } = CommanForm({ validationSchema: MyProfileDetailValidation });


    const handleImage = (e: any, index: number) => {
        handleImageChange({ e, index, selectedImages, setSelectedImages, setValue, trigger, validateImage, validImageTypes, getImages, setGetImages })
    };


    const validImagesCount = selectedImages.filter((image: any) => image.file_path).length;

    const handleRemoveImage = async (media_id: number | string | null, index: number) => {

        let imageData: any[] = [];
        let confirmation = await handleShowSwalConfirmation(intl.formatMessage({ id: 'you_want_to_remove' }), true, true, intl.formatMessage({ id: 'are_you_sure' }));

        if (confirmation) {
            let updatedImages;
            if (media_id) {
                updatedImages = selectedImages.filter((img: any) => img.media_id !== media_id);
            } else {
                updatedImages = [...selectedImages];
                updatedImages.splice(index, 1);
            }

            setSelectedImages([...updatedImages, { file_path: null, media_id: null }]);
            // setSelectedImages(updatedImages);
            imageData = updatedImages.filter((item: any) => item?.file_path != null);

            if (imageData.length >= 5) {
                setValue('image', imageData);
            } else {
                setValue('image', []);
            }

            // imgArr.push(media_id)

            if (media_id) {
                // setImgArr([...imgArr, media_id])
                dispatch(RemoveProfileImageAction({ delete_id: media_id }));
            }
        }

        trigger("image")
    };




    useEffect(() => {
        setValue("description", profileData?.data?.data?.description ? profileData?.data?.data?.description : "")
        setValue('location', (profileData?.data?.data?.location ? profileData?.data?.data?.location : "") + (profileData?.data?.data?.country ? ", " + profileData?.data?.data?.country : ""));
        setValue('phone_country_code', profileData?.data?.data?.phone_country_code);
        setValue('phone_number', profileData?.data?.data?.phone_number);
    }, [profileData]);


    useEffect(() => {

        if (profileData?.data?.data?.buisness_images) {
            let arr: any = [...profileData?.data?.data?.buisness_images]
            for (let i = 1; i <= 10 - profileData?.data?.data?.buisness_images?.length; i++) {
                arr.push({ file_path: null, media_id: null })
            }
            setSelectedImages(arr)
        }

        if (profileData?.data?.data?.buisness_images?.length >= 5) {
            setValue('image', profileData?.data?.data?.buisness_images)
        }


    }, [profileData]);


    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number")
    }

    const [imageError, setImageError] = useState("")
    const onSubmit = (payload: any) => {
        const formData = new FormData();

        const data = selectedImages.filter((item: any) => item?.file_path != null);
        // if (imgArr?.length > 0) {
        //     dispatch(RemoveProfileImageAction({ delete_id: imgArr }));
        // }

        if (data?.length < 5) {
            setImageError("Please select 5 images.")
            return
        }

        setImageError("")
        if (imageData?.length > 0) {
            for (let i = 0; i < imageData?.length; i++) {
                formData.append('buisness_images', imageData[i]);
            }
        }


        formData.append("location", payload?.location)
        formData.append("s_lat", latitude)
        formData.append("s_long", longitude)
        formData.append("description", payload?.description)
        formData.append("phone_number", payload?.phone_number)
        formData.append("phone_country_code", `+${payload?.phone_country_code.replace(/^\++/, '')}`)
        formData.append("deleted_images_id", JSON.stringify(deletedImagesId))
        dispatch(SalonUpdateAction(formData))
    }



    const handleCloseButton = () => {
        reset()
        setDeletedImagesId([])
        setImageData([])
        // setImgArr([])
    }


    useEffect(() => {
        if (profile_data?.status) {
            reset()
            $(".salon-model-box").click()
            dispatch(SalonUpdateAction("RESET"))

            dispatch(SalonDetailAction({ detail_id: profile?.data?.data?.id }))
            setDeletedImagesId([])
            // setImgArr([])
            setImageData([])

        }
    }, [profile_data])

    useEffect(() => {
        return () => {
            dispatch(SalonUpdateAction("RESET"))
            $('.modal-backdrop').remove();
        }
    }, []);


    const [latitude, setLatitude]: any = useState(null)
    const [longitude, setLongitude]: any = useState(null)


    const handleLocationSuccess = (result: any) => {
        setLatitude(result?.latitudeLongitude?.lat)
        setLongitude(result?.latitudeLongitude?.lng)
        setValue('location', result?.formattedAddress)
        trigger('location')
    }


    const handleCurrentLocation = async () => {
        const address: any = await getLocationAddress({ type: 'current' });
        setLatitude(address?.latitude)
        setLongitude(address?.longitude)
        if (address?.status === 'SUCCESS') {
            setValue('location', address?.address)
            trigger("location")
        };
    }


    return (
        <>
            <div className="modal modelStyle fade" id="salondetailsEnd" tabIndex={-1} aria-labelledby="exampleModalLabel" data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false">
                {salon_detail?.loading ? <Spinner /> : ""}
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage id="edit_salon_detail" /></h1>
                            <button type="button" className="btn p-0 f-20 salon-model-box btnClose" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='photoGrid'>

                                    {
                                        selectedImages?.length > 0 && selectedImages?.map((item: any, index: any) => {
                                            return (
                                                <MyProfileImageItem
                                                    key={index}
                                                    onImageRemove={(file: any) => handleRemoveImage(item?.media_id, index)}
                                                    onImageSelect={(file: any) => handleImage(file, index)}
                                                    setDeletedImagesId={setDeletedImagesId}
                                                    index={index}
                                                    selectedImages={selectedImages}
                                                    image={item}
                                                    errors={errors}
                                                    setImageData={setImageData}
                                                    imageLength={validImagesCount}
                                                    {...register("image")}
                                                />
                                            )
                                        })
                                    }
                                    {imageError ? <p className='text-danger'>{imageError}</p> : <Errormessages errors={errors} name="image" />}






                                </div>
                                <div className='ReactinputIcon mb-4'>
                                    {/* <label className="form-label">Phone</label> */}
                                    <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={`${watch('phone_country_code')}${watch('phone_number')}`} />
                                    {/* <input type="number" className="form-control" placeholder='Enter Number' /> */}
                                    <span className="iconLeft icon-call"></span>
                                    <Errormessages errors={errors} name="phone_number" />


                                </div>
                                <div className='normalINput mb-4'>
                                    <label className="form-label"><FormattedMessage id="about_salon" /> </label>
                                    <textarea className='form-control' rows={4} placeholder='Enter Description'
                                        {...register("description")}
                                        onInput={(e: any) => {
                                            const value = e.target.value.replace(/\s{2,}/g, ' ');
                                            setValue('description', value);

                                        }}
                                    >{ }</textarea>
                                    <Errormessages errors={errors} name="description" />
                                </div>
                                <div className='inputIcon mb-4'>
                                    <label className="form-label"><FormattedMessage id="location" /></label>
                                    {/* <input type="text" className="form-control" placeholder='Enter Location'
                                        {...register("location")}
                                        onInput={(e: any) => {
                                            const value = e.target.value.replace(/\s{2,}/g, ' ');
                                            setValue('location', value);

                                        }}
                                    /> */}
                                    <ProfileLocation
                                        id='home-pickup-input'
                                        className="form-control"
                                        onSuccess={handleLocationSuccess}
                                        value={watch("location")}
                                        placeholder='Enter Location'
                                        onChange={(e) => {
                                            setValue('location', e?.target?.value)
                                            trigger('location')
                                        }}
                                    />

                                    <span className="iconLeft icon-location"></span>
                                    <span className="iconRight icon-gps" onClick={handleCurrentLocation}></span>

                                    <Errormessages errors={errors} name="location" />


                                </div>
                                <div className='row gy-3 mt-5 align-items-stretch'>
                                    <div className='col-sm-4'><button type="button" className="btn btnOUtlinegray h-100 w-100" data-bs-dismiss="modal" onClick={handleCloseButton} disabled={profile_data?.loading}><FormattedMessage id="cancel" /></button></div>
                                    <div className='col-sm-8'>
                                        <Button text={<FormattedMessage id="submit" /> as any} className="btn btn-fill w-100" type="submit" isLoading={profile_data?.loading} />
                                        {/* // <button type="submit" className="btn btn-fill w-100">Submit</button> */}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SalonDetailsEdit